import { Box, Chip, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useTheme } from "@mui/styles";
import React from "react";

const AppliedFilters = ({ filters, handleClearAll, ignoreFilters }) => {
  const theme = useTheme();
  const handleDelete = (deleted, selected, onChange, type) => () => {
    if (type === "distance") {
      onChange([{ locationType: "current", miles: 0, zip: "" }]);
    } else onChange(selected?.filter((v) => v !== deleted));
  };
  const getChipData = (filter, val) => {
    if (filter?.type === "checklist") {
      return filter?.data.find((d) => d.id === val).name;
    } else if (filter?.type === "venues") {
      return val.venue_name;
    } else if (filter?.type === "bands") {
      return val.bandname;
    } else if (
      filter?.type === "distance" &&
      ((val?.locationType === "zip" && val?.zip) ||
        val?.locationType === "current" ||
        val?.locationType === "default")
    ) {
      return val?.message;
    } else if (filter.type === "year") {
      return val;
    } else return val;
  };
  return (
    <div>
      <Box
        sx={{
          display: "flex",
          alignItems: "center", // Ensure vertical alignment
          flexWrap: "wrap",
          gap: 0.5,
          marginTop: 2,
          marginBottom: ignoreFilters ? 0 : 2,
          mx: "8px",
          minHeight: "35px",
          bgcolor: filters?.length > 0 ? "#fff" : "#e6e6e6",
          padding: "8px",
          borderRadius: "5px",
          position: "relative", // Needed for absolute positioning of the close button
        }}
      >
        {filters?.length > 0 ? (
          filters?.map((filter, index) => (
            <Box key={"my-filters-" + index}>
              {filter?.selectedValues.map((val, i) => (
                <Chip
                  key={val + i}
                  label={getChipData(filter, val)}
                  onDelete={handleDelete(
                    val,
                    filter?.selectedValues,
                    filter?.onChange,
                    filter?.type
                  )}
                  sx={{
                    background: filter?.colorCode?.secondary
                      ? filter?.colorCode?.secondary
                      : theme?.primaryColor,
                    color:
                      filter?.colorCode?.secondary && filter?.colorCode?.primary
                        ? filter?.colorCode?.primary
                        : "#fff",
                    "& .MuiChip-deleteIcon": {
                      color:
                        filter?.colorCode?.secondary &&
                        filter?.colorCode?.primary
                          ? filter?.colorCode?.primary
                          : "#fff",
                    },
                  }}
                />
              ))}
              <IconButton
                onClick={handleClearAll}
                sx={{
                  position: "absolute",
                  right: 8,
                  top: "50%",
                  transform: "translateY(-50%)",
                }}
              >
                <CloseIcon />
              </IconButton>
            </Box>
          ))
        ) : (
          <Typography
            sx={{
              mt: "4px",
              color: "#c1c1c1",
            }}
          >
            No filters applied
          </Typography>
        )}
      </Box>
      {ignoreFilters && (
        <Typography
          sx={{
            fontStyle: "italic",
            fontSize: "12px",
            marginBottom: 2,
            mx: "8px",
          }}
        >
          Turn off ignore filters switch to get filtered results
        </Typography>
      )}
    </div>
  );
};

export default AppliedFilters;
